import React from "react";
import { MinimalContainer } from "../../styles/Theme";
import styled from "styled-components";
const Container = styled(MinimalContainer)`
  padding: 20px;
  margin: 0 auto;
`;

const ErrorComponent = ({ componentStack, error }) => (
  <Container>
    <p style={{ color: "red", fontWeight: "bold" }}>
      <strong>Oops! An error occured!</strong>
    </p>
    <p>Here’s what we know…</p>
    <p>
      <strong>Error:</strong> {error.toString()}
    </p>
    <p>
      <strong>Stacktrace:</strong> {componentStack}
    </p>
  </Container>
);

export default ErrorComponent;
